import {Injectable} from '@angular/core';
import {POObjectEffects} from '@store/effects/POObject.effect';
import {PODocType} from '@objects-module/model';

@Injectable()
export class PODocTypeEffects extends POObjectEffects<PODocType> {
  constructor() {
    super(PODocType.type);
  }
}
